export default __webpack_public_path__ + "static/media/tools.483ec069.svg";